import { FieldTypes, PopulatedAssessment, Shortcut, ShortcutMap } from '@hb/shared'

export const dateShortcuts: ShortcutMap = {
  name: 'Date',
  shortcut: true,
  children: {
    shortDate: {
      name: 'Date (short)',
      shortcut: true,
      type: FieldTypes.DATE,
    },
    longDate: {
      name: 'Date (long)',
      shortcut: true,
      type: FieldTypes.DATE,
    },
  },
}

export const getAddressShortcut = (name: string): ShortcutMap => ({
  name,
  shortcut: true,
  children: {
    address: {
      name: 'Address (1 line)',
      shortcut: true,
      type: FieldTypes.TEXT,
    },
    address2: {
      name: 'Address (2 line)',
      shortcut: true,
      type: FieldTypes.TEXT,
    },
    streetAddress: {
      name: 'Street Address',
      shortcut: true,
      type: FieldTypes.TEXT,
    },
    streetAddress2: {
      name: 'Street Address Line 2',
      shortcut: true,
      type: FieldTypes.TEXT,
    },
    fullStreetAddress: {
      name: 'Full Street Address',
      shortcut: true,
      type: FieldTypes.TEXT,
    },
    city: {
      name: 'City',
      shortcut: true,
      type: FieldTypes.TEXT,
    },
    state: {
      name: 'State / Territory',
      shortcut: true,
      type: FieldTypes.TEXT,
    },
    zip: {
      name: 'Zip Code',
      shortcut: true,
      type: FieldTypes.TEXT,
    },
  },
})

export const getAuthShortcuts = (assessment: PopulatedAssessment | undefined): ShortcutMap => ({
  name: 'Auth',
  shortcut: true,
  children: Object.keys(assessment?.authorizations ?? { atLeast1: {} }).reduce<
    Record<string, Shortcut>
  >(
    (acc, _, index) => ({
      ...acc,
      [`${index}`]: {
        name: `Authorization ${index + 1} Reference Number`,
        shortcut: true,
        type: FieldTypes.TEXT,
      },
    }),
    {},
  ),
})

export const patientItems: ShortcutMap = {
  name: 'Patient',
  shortcut: true,
  children: {
    fname: {
      name: 'First Name',
      shortcut: true,
      type: FieldTypes.TEXT,
    },
    lname: {
      name: 'Last Name',
      shortcut: true,
      type: FieldTypes.TEXT,
    },
    dob: {
      name: 'DOB',
      shortcut: true,
      type: FieldTypes.DATE,
    },
    // address: {
    //   name: 'Address (1 line)',
    //   shortcut: true,
    //   type: FieldTypes.TEXT,
    // },
    // address2: {
    //   name: 'Address (2 line)',
    //   shortcut: true,
    //   type: FieldTypes.TEXT,
    // },
    phone: {
      name: 'Phone Number',
      shortcut: true,
      type: FieldTypes.TEXT,
    },
    address: getAddressShortcut('Patient Address'),
    // homeAddress: {
    //   name: 'Home Address (1 line)',
    //   shortcut: true,
    //   type: FieldTypes.TEXT,
    // },
    // homeAddress2: {
    //   name: 'Home Address (2 line)',
    //   shortcut: true,
    //   type: FieldTypes.TEXT,
    // },
    homeAddress: getAddressShortcut('Home Address'),
  },
}

const fullNameItems: ShortcutMap = {
  name: 'Full Name',
  shortcut: true,
  children: {
    fullName: {
      name: 'Full Name (First Last)',
      shortcut: true,
      type: FieldTypes.TEXT,
    },
    reverseName: {
      name: 'Full Name (Last, First)',
      shortcut: true,
      type: FieldTypes.TEXT,
    },
    fullNameWithMiddle: {
      name: 'Full Name (First Middle Last)',
      shortcut: true,
      type: FieldTypes.TEXT,
    },
    fullNameWithMiddleInitial: {
      name: 'Full Name (First M Last)',
      shortcut: true,
      type: FieldTypes.TEXT,
    },
  },
}

export const consentFormPatientItems: ShortcutMap = {
  name: 'Patient',
  shortcut: true,
  children: {
    fullName: fullNameItems,
    ...patientItems.children,
  },
}

// practice contract signer — same user shortcuts as the consent form patient, minus addresses
export const signerItems: ShortcutMap = {
  name: 'Signer',
  shortcut: true,
  children: {
    fullName: fullNameItems,
    fname: patientItems.children.fname,
    lname: patientItems.children.lname,
    dob: patientItems.children.dob,
    phone: patientItems.children.phone,
  },
}

export const pregnancyItems: ShortcutMap = {
  name: 'Pregnancy',
  shortcut: true,
  children: {
    edd: {
      name: 'EDD',
      shortcut: true,
      type: FieldTypes.DATE,
    },
    lmp: {
      name: 'LMP',
      shortcut: true,
      type: FieldTypes.DATE,
    },
    firstVisit: {
      name: 'Date of First Visit',
      shortcut: true,
      type: FieldTypes.DATE,
    },
  },
}
